<template>
  <div class="d-flex flex-column flex-grow-1 position-relative">
    <PageHeader>
      <template #default>Announcements</template>
      <template #right>
        <!--
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a class="nav-link disabled">Display as</a>
          </li>
          <li class="nav-item">
            <router-link class="nav-link d-flex" active-class="active" :to="{ params: { display_as: 'list' } }">
              <span class="material-icons">list</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link d-flex" active-class="active" :to="{ params: { display_as: 'map' } }">
              <span class="material-icons">place</span>
            </router-link>
          </li>
        </ul>
        <span class="hr-vert d-none d-md-flex" style="height: 2rem; background: rgba(0, 0, 0, 0.25)" />
        -->
        <div class="dropdown">
          <a class="btn btn-primary dropdown-toggle d-flex gap-2" href="#" role="button" data-bs-toggle="dropdown">
            <span class="material-icons">add</span>
            Create Announcement
          </a>
          <ul class="dropdown-menu">
            <li v-for="type of state.types" :key="type.value">
              <button class="dropdown-item" @click="createAnnouncement(`${type.value}`)">{{ type.text }}</button>
            </li>
          </ul>
        </div>
      </template>
    </PageHeader>
    <transition appear name="fade">
      <div v-if="state.meta" class="content d-flex flex-column flex-grow-1 position-relative">
        <div style="z-index: 2" class="card card-rounded mb-3">
          <div class="card-body">
            <Filter :meta="state.meta" @filter="state.filters = $event" :datasets="state.datasets" />
          </div>
        </div>
        <transition appear name="fade" mode="out-in">
          <CMSTable
            ref="table"
            title="Announcements"
            v-if="$route.params.display_as === 'list'"
            :filters="state.filters"
            name="announcements"
            view
            edit
          />
          <places-map v-else collection="announcements" route="announcements" :filters="state.filters" />
        </transition>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue'
import { NavigationGuard } from 'vue-router'
import axios from '@/api'
import Swal from 'sweetalert2'

import { slugify } from '@/utils/misc'
import { PageHeader } from '@avriopolis/common/components'
import project from '@/store/project'

import CMSTable from '@/components/misc/CMSTable.vue'
import PlacesMap from '@/components/misc/PlacesMap.vue'
import Filter from '@/components/misc/Filter.vue'

const routeGuard: NavigationGuard = (to, _from, next) => {
  if (!to.params.display_as) {
    return next({ ...to, params: { ...to.params, display_as: 'list' } })
  }
  next()
}

export default defineComponent({
  name: 'Announcements',
  emits: ['loading'],
  components: {
    PageHeader,
    Filter,
    CMSTable,
    PlacesMap,
  },
  setup(props, { emit }) {
    const table = ref()
    const state = reactive({
      meta: undefined,
      filters: {},
      datasets: {},
      types: [] as { text: string; value: string }[],
    })

    const fetchData = async () => {
      const meta = await axios.get(`/custom/meta/announcements?filter[projects_id]=${project?.active?.id}`)
      state.meta = meta?.data ?? meta

      const field = await axios.get('/fields/announcements/type')
      state.types = field?.data?.data?.meta?.options?.choices ?? []
    }

    async function updateData() {
      emit('loading', true)
      try {
        await fetchData()
      } catch (e) {}
      emit('loading', false)
    }

    async function createAnnouncement(type: string) {
      const result = await Swal.fire({
        input: 'text',
        inputLabel: 'Announcement Title',
        inputPlaceholder: 'Title',
        showCancelButton: true,
        confirmButtonText: 'Create',
        confirmButtonColor: '#0d6efd',
      })

      if (result.isConfirmed) {
        if (!result.value) {
          Swal.fire('Invalid', 'A title must be entered', 'error')
        } else {
          await axios.post('items/announcements', {
            title: [{ lang: 'en-US', value: result.value }],
            source: 'manual',
            slug: slugify(result.value),
            projects_id: project.active?.id,
            type,
          })

          table?.value?.table?.update()
        }
      }
    }

    updateData()

    return { state, createAnnouncement, table }
  },
  beforeRouteUpdate: routeGuard,
  beforeRouteEnter: routeGuard,
})
</script>
